import React from "react";
import styles from "./Filters.module.scss";
import { HELP_WITH_FILTERS } from "./FilterMappings";

export default function HelpWith(props) {

    const {currentHelpWith, setCurrentHelpWith} = props;
    const options = HELP_WITH_FILTERS

    const selectHelpWith = (key) => {
        if (currentHelpWith === key) {
            return setCurrentHelpWith(0)
        }

        return setCurrentHelpWith(key)
    }

    return (
        <>
            <div className={styles.formSection}>
                <h3>What do you need help with?</h3>
                <div className={styles.verticaloffsetmedium }>Whether it's planning for a big purchase or managing unexpected wealth, pinpoint what you're looking for to find advisors.</div>
                    <div className={styles.helpWithContainer}>
                    {options.map((item) => {
                        return <div className={currentHelpWith === item.key ?  styles.helpWithSelected : styles.helpWith} key={item.key} onClick={() => selectHelpWith(item.key)}><img className={styles.helpWithImg} src={item.icon} alt=""/>{item.text}</div>
                    })}
                </div>
            </div>
        </>
    )
}